// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Footer_footer__BKhgK {\n    /* position: absolute; */\n    width: 90vw;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    padding-top: 50px;\n}", "",{"version":3,"sources":["webpack://src/components/footer/Footer.module.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;AACrB","sourcesContent":[".footer {\n    /* position: absolute; */\n    width: 90vw;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    padding-top: 50px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": "Footer_footer__BKhgK"
};
export default ___CSS_LOADER_EXPORT___;
